import "./index.css";
import React from "react";
import NavigationRoutes from "./navigation";
import { BrowserRouter } from "react-router-dom";

function App() {
  return (
    <BrowserRouter>
      <div id="app">
        <NavigationRoutes />
      </div>
    </BrowserRouter>
  );
}

export default App;
